import { DwParsonsPuzzle } from "@dodona/widgets";
import { initDescription } from "@/description";
import "@/components/composite/open_question";

window.DwParsonsPuzzle = DwParsonsPuzzle;

// Runs after the frame layout has set the locale on dodona.ready.
dodona.ready.then(initDescription);

// Only pull in Papyros + CodeMirror (~1 MB) when a description actually uses a
// code playground.
if (document.querySelector("dw-code-playground")) {
    void import("@/components/code_playground/code_playground");
}
